import React from "react"


const BookLoading = () => {

    return (
        <div className="book-wrapper">
            <div className="book">
                <div className="book__page"></div>
                <div className="book__page"></div>
                <div className="book__page"></div>
            </div>
            <div className="txt">
                <p id="movetext">Reason overruling and persuading necessity</p>
                <p id="movename">Plato</p>
            </div>
        </div>
    );
}

export default BookLoading



// WEBPACK FOOTER //
// ./src/components/BookLoading.jsx